module.exports = __webpack_public_path__ + "img/Middle-Horizontal-Rectangular-Attachment-21.5da7149f.png";